// T-136 (v1.8.39, Session 37, 29.09.2026): Rücksprung nach der Anmeldung. Die Annahmeseite eines Angebots
// (/angebot-annehmen/:id) leitet nicht angemeldete Gäste nach /login?returnUrl=... ; LoginForm wertete returnUrl nicht aus,
// der Gast landete im Dashboard und musste zurück in die Angebots-Mail (Kundin 29.09.2026 10:37).
// Nur relative Pfade dieser Anwendung sind erlaubt (kein offener Redirect), Verwaltungsbereich und Anmeldeseiten ausgeschlossen.

const VERBOTENE_PRAEFIXE = ['/admin', '/login', '/register', '/logout'];

/** Liefert einen sicheren relativen Rücksprungpfad oder null. */
export function sichererRuecksprung(roh: string | null | undefined): string | null {
  if (!roh) return null;
  let pfad = roh.trim();
  try {
    // URLSearchParams dekodiert bereits einmal; doppelt kodierte Werte (encodeURIComponent vor dem Anhängen) nachziehen
    if (/%2f|%3f|%3d|%26/i.test(pfad)) pfad = decodeURIComponent(pfad);
  } catch {
    return null;
  }
  if (!pfad.startsWith('/')) return null;
  if (pfad.startsWith('//') || pfad.startsWith('/\\')) return null;
  if (pfad.includes('\\') || Array.from(pfad).some(z => z.charCodeAt(0) < 32)) return null;
  if (/^\/[^/?#]*:/.test(pfad)) return null;
  const nurPfad = pfad.split(/[?#]/)[0].toLowerCase();
  if (VERBOTENE_PRAEFIXE.some(p => nurPfad === p || nurPfad.startsWith(p + '/'))) return null;
  if (pfad.length > 500) return null;
  return pfad;
}
